<template>
  <div class="table-container">
    <div
      v-if="hasColumnPropertySetting"
      :id="`columnPropertySetting-${id}`"
      ref="columnPropertySetting"
      class="column-property-setting"
      @click="openColumnPropertySetting"
    >
      <img
        :src="$img.get('Tools/ColumnPropertySetting.svg')"
        alt="ColumnPropertySetting"
      />
    </div>
    <teleport to="body">
      <columnPropertyModal
        ref="columnPropertyModal"
        :isSelector="isSelector"
        :columns="validColumns"
        :trigger="columnPropertyModalTrigger"
        :position="modalPosition"
        @onSaved="onSavedColumnProperty"
        @onClosed="onClosedColumnProperty"
      ></columnPropertyModal>
    </teleport>
    <div ref="table" class="table-responsive">
      <table
        class="table"
        :class="isSelects ? 'table-selects' : ''"
        :style="getTableStyle()"
      >
        <thead
          :id="id"
          :style="
            isSelects
              ? 'background-color: #f5f6f8;'
              : 'background-color: white;'
          "
          style="user-select: none"
        >
          <tr>
            <slot name="th-before"></slot>
            <th
              v-for="column in showColumns"
              :key="column.ColumnName"
              :style="{
                width: column.Width + 'px',
                position: 'relative',
                paddingRight: column.hasReturn ? '50px' : '',
              }"
              class="th-column-name"
              :class="column.class ? column.class : 'text-left'"
              @click="!isReadonly ? thClick(column, $event) : null"
            >
              {{ column.text
              }}<span
                v-if="sortName == column.ColumnName"
                :class="{ isReverse: isDesc == 1 }"
                style="margin-left: 5px"
              >
                <img :src="$img.get('Icon/TableSortArrow.svg')" alt="Sort" />
              </span>
              <img
                v-if="
                  !isReadonly &&
                  column.ColumnName == 'Memo' &&
                  column.hasDropDown
                "
                :src="$img.get('Icon/TriangleDown.svg')"
                style="margin-left: 5px"
                alt="TriangleDown"
              />

              <span v-if="column.ColumnName == 'Cost' && column.hasDropDown">{{
                "(" + currentDetsCost.text + ")"
              }}</span
              ><img
                v-if="
                  !isReadonly &&
                  column.ColumnName == 'Cost' &&
                  column.hasDropDown
                "
                :src="$img.get('Icon/TriangleDown.svg')"
                style="margin-left: 5px"
                alt="TriangleDown"
              />

              <div
                v-if="column.hasReturn"
                class="tool-button"
                style="
                  position: absolute;
                  top: 14px;
                  right: 0;
                  margin-right: 16px;
                "
                @click="onAuto(column)"
              >
                <img :src="$img.get('Tools/Return.svg')" alt="Return" />
              </div>

              <teleport to="body">
                <dialogModal
                  v-if="column.hasDropDown"
                  id="dropdownTypes"
                  class="memo"
                  :trigger="dropdownTypeTrigger"
                  :conditionTypes="dropdownTypes"
                  :style="dropdownStyle"
                  @addCondition="setDetsDropDown"
                ></dialogModal
              ></teleport>
              <div
                class="resize-bar"
                @mousedown="mousedown($event, column)"
                @click.stop="1 == 1"
              ></div>
            </th>
            <slot name="th-after"></slot>
          </tr>
        </thead>
        <slot name="tbody"></slot>
        <draggable
          v-if="hasDraggable"
          tag="tbody"
          v-model="draggableItems"
          :item-key="(item) => item[idProperty]"
          :handle="draggableHandle"
          @start="onDragStart"
          @end="onDragEnd"
        >
          <template #item="{ element: item, index }">
            <tr
              @click="trClick(item, index)"
              @dblclick="trdbClicked(item)"
              :class="{ 'tr-selected': currentIndex === index }"
            >
              <!-- slot 前置欄位 -->
              <slot name="td-before" :item="item" :index="index"></slot>

              <!-- 資料欄位 -->
              <template
                v-for="column in showColumns"
                :key="column.ColumnName"
              >
                <slot name="td" :column="column" :item="item">
                  <tdPart
                    :column="column"
                    :item="item"
                    @clickTd="clickTd"
                  >
                    <template v-if="column.hasAddCircleButton" #td-button>
                      <div
                        class="tool-button mx-0 mt-1px mr-5px"
                        @click="clickTdButton(item)"
                      >
                        <img
                          :src="$img.get('Tools/AddCircle.svg')"
                          alt="AddCircle"
                        />
                      </div>
                    </template>
                  </tdPart>
                </slot>
              </template>
              <!-- slot 後置欄位 -->
              <slot name="td-after" :item="item"></slot>
            </tr>
          </template>
        </draggable>
        <tbody v-else>
          <tr
            v-for="(item, index) in items"
            :key="item[idProperty]"
            @click="trClick(item, index)"
            :class="{ 'tr-selected': currentIndex == index }"
            @dblclick="trdbClicked(item)"
          >
            <slot name="td-before" :item="item" :index="index"></slot>
            <template v-for="column in showColumns" :key="column.ColumnName">
              <slot name="td" :column="column" :item="item">
                <tdPart
                  :column="column"
                  :item="item"
                  @clickTd="clickTd"
                >
                  <template v-if="column.hasAddCircleButton" #td-button>
                    <div
                      class="tool-button mx-0 mt-1px mr-5px"
                      @click="clickTdButton(item)"
                    >
                      <img
                        :src="$img.get('Tools/AddCircle.svg')"
                        alt="AddCircle"
                      />
                    </div>
                  </template>
                </tdPart>
              </slot>
            </template>
            <slot name="td-after" :item="item"></slot>
          </tr>
          <tr v-if="hasTotal && items.length > 0" class="tr-total">
            <td
              v-for="(itemTotal, index) in itemTotals"
              :key="index"
              :class="itemTotal.class"
            >
              {{ itemTotal.value }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <slot name="inner-pagination-tool"></slot>
  </div>
</template>

<script>
import tdPart from "./tdPart.vue";
import dialogModal from "@/components/modals/DialogModal.vue";
import columnPropertyModal from "@/components/modals/ColumnPropertyModal.vue";
import draggable from "vuedraggable";
import currencyFilter from "@/filters/currency";
import discountFilter from "@/filters/discount";

export default {
  data() {
    return {
      currentIndex: -1,
      currentTh: null,
      startOffset: null,
      cursor: "pointer",
      validColumns: [],
      id: this.$func.uuid.get(),
      sortName: "",
      isDesc: 0,
      validTableName: this.getValidTableName(),
      dropdownTypeTrigger: false,
      dropdownTypes: [],
      currentDetsMemo: {
        value: 0,
        name: "Customize",
        text: "自訂",
      },
      currentDetsCost: {
        value: 0,
        name: "StandardCost",
        text: "標準成本",
      },
      columnPropertyModalTrigger: false,
      modalPosition: { top: 0, left: 0 },
      dropdownStyle: {},
      draggableItems: [],
      draggingIndex: null,
      itemTotals: [],
      currentColumnName: null,
    };
  },
  props: [
    "isSelects",
    "columns",
    "items",
    "idProperty",
    "changeIndex",
    "viewName",
    "tableName",
    "noHide",
    "noInitialTableName",
    "initialWidth",
    "isSortable",
    "noColumnPropertySetting",
    "useLocalColumns",
    "hasDraggable",
    "draggableHandle",
    "hasTotal",
    "isERP",
    "defaultPurchaseCostType",
    "isSelector",
    "isReadonly",
  ],
  emits: [
    "currentIndexChanged",
    "trClick",
    "setDetsMemo",
    "setDetsCost",
    "getSort",
    "onDragEnd",
    "onAuto",
    "clickTdButton",
    "clickTd",
  ],
  components: {
    tdPart,
    dialogModal,
    columnPropertyModal,
    draggable,
  },
  computed: {
    showColumns() {
      return this.validColumns.filter((col) => {
        return col.IsVisible;
      });
    },
    validViewName() {
      if (this.viewName) return this.viewName;
      else return this.$route.name;
    },
    isBusiness() {
      // return window.localStorage["roleType"] == 0;
      return true;
    },
    hasColumnPropertySetting() {
      return !this.noColumnPropertySetting && !this.useLocalColumns;
    },
    hasColumnPropertyPersistence() {
      return !this.useLocalColumns;
    },
  },
  watch: {
    tableName: {
      handler() {
        this.scheduleUpdateValidColumns();
      },
      immediate: true,
    },
    viewName() {
      this.scheduleUpdateValidColumns();
    },
    currentIndex() {
      this.currentIndexChanged();
    },
    changeIndex(value) {
      this.currentIndex = value;
    },
    showColumns() {
      this.computeTotals();
    },
    items: {
      handler(value) {
        this.draggableItems = JSON.parse(JSON.stringify(value));
        if (
          this.currentIndex < 0 ||
          this.currentIndex + 1 > this.items.length
        ) {
          if (this.items.length > 0) {
            this.currentIndex = 0;
          } else {
            this.currentIndex = -1;
          }
        } else {
          this.currentIndexChanged();
        }
        this.computeTotals();
        // if (this.hasDraggable) {
        //   let tableResponsive = document.querySelector(".table-responsive");
        //   tableResponsive.scrollTop = 0;
        //   tableResponsive.scrollLeft = 0;
        // }
      },
      deep: true,
    },
    dropdownTypeTrigger(value) {
      if (value) {
        this.$nextTick(() => {
          document.addEventListener("click", this.hideDropDownTypeList, true);
        });
      } else {
        document.removeEventListener("click", this.hideDropDownTypeList, true);
      }
    },
    defaultPurchaseCostType(value) {
      this.currentDetsCost = this.$enum.purchaseCostType.getByValue(value);
    },
  },
  methods: {
    clickTd(item) {
      this.$emit("clickTd", item);
    },
    scheduleUpdateValidColumns() {
      this.validTableName = this.getValidTableName();
      if (this.validTableName) {
        this.updateValidColumns();
      }
    },
    computeTotals() {
      this.itemTotals = [];
      if (this.hasTotal && this.items.length > 0) {
        let arr = this.showColumns;

        arr.forEach((column) => {
          if (
            column.ColumnName == "Total" ||
            column.ColumnName == "Cash" ||
            column.ColumnName == "CreditCardPrice" ||
            column.ColumnName == "DiscountPrice" ||
            column.ColumnName == "FreePrice" ||
            column.ColumnName == "PayType1" ||
            column.ColumnName == "PayType2" ||
            column.ColumnName == "LinePay" ||
            column.ColumnName == "Scan2Pay" ||
            column.ColumnName == "TotalCost" ||
            column.ColumnName == "GrossProfit" ||
            column.ColumnName == "People" ||
            column.ColumnName == "Sheets" ||
            column.ColumnName == "FoodCounts" ||
            column.ColumnName == "Deposit" ||
            column.ColumnName == "FreeDeposit" ||
            column.ColumnName == "OrderCounts"
          ) {
            this.calculateTotal(column.ColumnName, undefined, column);
          } else if (column.ColumnName == "GrossMargin") {
            column.filter = "discount";
            this.calculateTotal("GrossProfit", "Total", column);
          } else if (column.ColumnName == "FoodAverageSalPrice") {
            this.calculateTotal("Total", "FoodCounts", column);
          } else if (column.ColumnName == "TotalPerReceipt") {
            this.calculateTotal("Total", "Sheets", column);
          } else if (column.ColumnName == "FoodCountsPerReceipt") {
            this.calculateTotal("FoodCounts", "Sheets", column);
          } else if (column.ColumnName == "PeoplePerReceipt") {
            this.calculateTotal("People", "Sheets", column);
          } else if (column.ColumnName == "TotalPerPerson") {
            this.calculateTotal("Total", "People", column);
          } else if (column.ColumnName == "FoodCountsPerPerson") {
            this.calculateTotal("FoodCounts", "People", column);
          } else {
            this.itemTotals.push({ value: "", class: undefined });
          }
        });
      }
    },
    calculateTotal(dividendName, divisorName, column) {
      let dividend = 0;
      let divisor = 0;
      this.items.forEach((item) => {
        if (item[dividendName] || item[dividendName] == 0) {
          dividend = dividend + Number(item[dividendName]);
        }
        if (item[divisorName] || item[divisorName] == 0) {
          divisor = divisor + Number(item[divisorName]);
        } else {
          divisor = 1;
        }
      });
      this.totalFilter(column, dividend / divisor);
    },
    totalFilter(column, val) {
      val = Math.round((val + Number.EPSILON) * 100) / 100;
      let obj = {};
      if (column.filter == "currency") {
        obj = {
          value: currencyFilter(val),
          class: column.class,
        };
      } else if (column.filter == "discount") {
        obj = {
          value: discountFilter(val * 100),
          class: column.class,
        };
      } else {
        obj = {
          value: val,
          class: column.class,
        };
      }
      this.itemTotals.push(obj);
    },
    onAuto(column) {
      this.$emit("onAuto", column);
    },
    clickTdButton(item) {
      this.$emit("clickTdButton", item);
    },
    onDragStart(evt) {
      this.currentIndex = evt.oldIndex;
      this.draggingIndex = evt.oldIndex;
    },
    onDragEnd(evt) {
      this.currentIndex = evt.newIndex;
      this.draggingIndex = null;
      this.$emit("onDragEnd", this.draggableItems);
    },
    setDetsDropDown(item) {
      if (this.currentColumnName == "Memo") {
        this.setDetsMemo(item);
      } else if (this.currentColumnName == "Cost") {
        this.setDetsCost(item);
      }
    },
    setDetsMemo(item) {
      this.currentDetsMemo = item;
      this.hideDropDownTypeList();
      this.$emit("setDetsMemo", item);
    },
    setDetsCost(item) {
      this.currentDetsCost = item;
      this.hideDropDownTypeList();
      this.$emit("setDetsCost", item);
    },
    hideDropDownTypeList() {
      this.dropdownTypeTrigger = false;
    },
    thClick(column, e) {
      let columnName = column.ColumnName;
      if (column.hasDropDown) {
        this.currentColumnName = column.ColumnName;
        this.dropdownTypeTrigger = true;
        this.setDialogModal(e, column.ColumnName);
      } else if (this.isSortable) {
        if (this.sortName != columnName) {
          this.sortName = columnName;
          this.isDesc = 0;
        } else {
          this.sortName = columnName;
          this.isDesc = this.isDesc == 0 ? 1 : 0;
        }
        this.$emit("getSort", { sortName: this.sortName, isDesc: this.isDesc });
      }
    },
    setDialogModal(e, name) {
      const trigger = e.currentTarget;
      const dropdown = document.getElementById("dropdownTypes");
      if (name == "Memo") {
        this.dropdownTypes = [
          {
            value: 1,
            name: "Barcode1",
            text: "條碼1",
          },
          {
            value: 2,
            name: "Barcode2",
            text: "條碼2",
          },
          {
            value: 3,
            name: "Barcode3",
            text: "條碼3",
          },
          {
            value: 4,
            name: "FoodMemo",
            text: "商品備註",
          },
          {
            value: 5,
            name: "FoodName2",
            text: "商品名稱2",
          },
        ];
      } else if (name == "Cost") {
        this.dropdownTypes = [
          {
            value: 0,
            name: "StandardCost",
            text: "標準成本",
          },
          {
            value: 2,
            name: "PreviousCost",
            text: "前次進貨價",
          },
        ];
      }
      if (!trigger || !dropdown) return;

      const rect = trigger.getBoundingClientRect();

      this.dropdownStyle = {
        position: "absolute",
        top: `${rect.bottom + window.scrollY - 5}px`,
        left: `${rect.left + window.scrollX + 120}px`,
        zIndex: 20,
      };
    },
    currentIndexChanged() {
      this.$emit("currentIndexChanged", this.currentIndex);
    },
    trClick(item, index) {
      this.currentIndex = index;
      this.$emit("trClick", item);
    },
    trdbClicked(item) {
      this.$emit("trdbClicked", item);
    },
    getValidTableName() {
      if (this.tableName) return this.tableName;
      else if (this.noInitialTableName) return undefined;
      else return "data";
    },
    getTotalWidth() {
      let width = this.initialWidth ? parseInt(this.initialWidth) : 0;

      // 累加 showColumns 的宽度
      this.showColumns.forEach((column) => {
        width += column.Width;
      });

      const table = this.$refs.table;
      const slotHeaders = table?.querySelectorAll(
        "thead th:not(.th-column-name)"
      );
      slotHeaders?.forEach((header) => {
        const inlineStyleWidth = header.style.width;
        if (inlineStyleWidth === "auto") return;

        const inlineWidth = parseInt(inlineStyleWidth.replace("px", ""));
        const computedWidth = parseInt(window.getComputedStyle(header).width);
        const slotWidth = isNaN(inlineWidth) ? computedWidth : inlineWidth;
        width += isNaN(slotWidth) ? 0 : slotWidth;
      });

      let tableWidth = null;
      if (table) {
        tableWidth = table.clientWidth;
      }
      if (tableWidth > width) {
        return `${tableWidth}px`;
      } else {
        return `${width}px`;
      }
    },
    getTableStyle() {
      const totalWidth = this.getTotalWidth();
      if (this.isSelects) {
        return { width: "100%", minWidth: totalWidth };
      }
      return { width: totalWidth, cursor: this.cursor };
    },
    updateValidColumns() {
      let allColumns = this.columns.map((column, index) => {
        let map = {
          ColumnName: column.name,
          Width: column.width,
          class: column.class,
          filter: column.filter,
          IsVisible: true,
          Position: index,
        };
        if (column.hasDropDown) map.hasDropDown = column.hasDropDown;
        if (column.hasReturn) map.hasReturn = column.hasReturn;
        if (column.headerText) map.headerText = column.headerText;
        if (column.defaultVisible) map.defaultVisible = column.defaultVisible;
        if (column.isClickable) map.isClickable = column.isClickable;
        if (column.isStatus) map.isStatus = column.isStatus;
        if (column.compareWith) map.compareWith = column.compareWith;
        if (column.extraClass) map.extraClass = column.extraClass;
        if (column.btnText) map.btnText = column.btnText;
        if (column.hasAddCircleButton)
          map.hasAddCircleButton = column.hasAddCircleButton;
        if (column.hasSpecification)
          map.hasSpecification = column.hasSpecification;
        if (column.hasERP) map.hasERP = column.hasERP;
        if (column.hasBatchNumber) map.hasBatchNumber = column.hasBatchNumber;
        if (column.multiDatas) map.multiDatas = column.multiDatas;
        if (column.titleProperty) map.titleProperty = column.titleProperty;
        if (column.itemProperty) map.itemProperty = column.itemProperty;
        if (column.firstValue) map.firstValue = column.firstValue;
        if (column.secondValue) map.secondValue = column.secondValue;
        if (column.thirdValue) map.thirdValue = column.thirdValue;
        if (column.linkImg) map.linkImg = column.linkImg;
        return map;
      });

      if (this.isBusiness && this.hasColumnPropertyPersistence) {
        this.$api.columnProperties
          .get(this.validViewName, this.validTableName)
          .then((data) => {
            let columns = [];
            if (data.length <= 0) {
              allColumns.forEach((allColumn, index) => {
                let origin = this.$func.getColumnProperty(allColumn.ColumnName);
                allColumn.class = origin.class;
                allColumn.filter = origin.filter;
                allColumn.Width = origin.Width;
                let hasDefaultInvisible = this.columns.find((c) => {
                  return (
                    this.isSameColumnName(c.name, allColumn.ColumnName) &&
                    c.defaultInvisible
                  );
                });
                if (
                  hasDefaultInvisible &&
                  !this.noHide &&
                  !this.noColumnPropertySetting
                ) {
                  allColumn.IsVisible = false;
                }
                if (index == allColumns.length - 1) {
                  this.$api.columnProperties.save(
                    this.validViewName,
                    this.validTableName,
                    allColumns
                  );
                  columns = allColumns;
                }
              });
            } else {
              if (this.noHide || this.noColumnPropertySetting) {
                allColumns.forEach((column) => {
                  data.forEach((d) => {
                    if (
                      this.isSameColumnName(column.ColumnName, d.ColumnName)
                    ) {
                      column.ColumnName = d.ColumnName;
                      column.Width = d.Width;
                      column.class = d.class;
                      column.filter = d.filter;
                    }
                  });
                });
              }
              let isModify = false;
              let removeColumnIndexs = [];
              data.forEach((column, index) => {
                const ind = allColumns.findIndex((d) =>
                  this.isSameColumnName(d.ColumnName, column.ColumnName)
                );
                if (ind < 0) {
                  isModify = true;
                  removeColumnIndexs.push(index);
                } else {
                  if (allColumns[ind].headerText)
                    column.headerText = allColumns[ind].headerText;
                  if (allColumns[ind].btnText)
                    column.btnText = allColumns[ind].btnText;
                  if (allColumns[ind].filter)
                    column.filter = allColumns[ind].filter;
                  if (allColumns[ind].extraClass)
                    column.extraClass = allColumns[ind].extraClass;
                  if (allColumns[ind].compareWith)
                    column.compareWith = allColumns[ind].compareWith;
                  if (allColumns[ind].multiDatas)
                    column.multiDatas = allColumns[ind].multiDatas;
                  if (allColumns[ind].titleProperty)
                    column.titleProperty = allColumns[ind].titleProperty;
                  if (allColumns[ind].itemProperty)
                    column.itemProperty = allColumns[ind].itemProperty;
                  if (allColumns[ind].firstValue)
                    column.firstValue = allColumns[ind].firstValue;
                  if (allColumns[ind].secondValue)
                    column.secondValue = allColumns[ind].secondValue;
                  if (allColumns[ind].thirdValue)
                    column.thirdValue = allColumns[ind].thirdValue;
                  if (allColumns[ind].linkImg)
                    column.linkImg = allColumns[ind].linkImg;
                }
              });
              for (let i = removeColumnIndexs.length - 1; i >= 0; i--) {
                data.splice(removeColumnIndexs[i], 1);
              }

              allColumns.forEach((column) => {
                let dataIndex = data.findIndex((d) =>
                  this.isSameColumnName(d.ColumnName, column.ColumnName)
                );
                if (dataIndex < 0) {
                  isModify = true;
                  if (
                    this.noHide ||
                    this.noColumnPropertySetting ||
                    column.defaultVisible
                  )
                    column.IsVisible = true;
                  else column.IsVisible = false;
                  data.push(column);
                }
              });
              if (data.every((d) => d.IsVisible == false)) {
                data[0].IsVisible = true;
              }
              let position = 1;
              data.forEach((column) => {
                if (column.IsVisible) {
                  column.Position = position;
                  position = position + 1;
                }
              });
              if (isModify) {
                this.$api.columnProperties.save(
                  this.validViewName,
                  this.validTableName,
                  data
                );
              }
              if (this.noHide || this.noColumnPropertySetting) {
                columns = allColumns;
              } else {
                columns = data;
              }
            }
            columns.forEach((column) => {
              let origin = this.$func.getColumnProperty(column.ColumnName);
              if (!column.class) column.class = origin.class;
              if (!column.filter) column.filter = origin.filter;
              if (!column.Width) column.Width = origin.Width;
              if (column.headerText && column.headerText.length > 0) {
                column.text = column.headerText;
              } else if (!column.text || column.text.length == 0) {
                column.text =
                  this.$t(`columnName.${column.ColumnName.toLowerCase()}`) ||
                  origin.text;
              }
              let c = allColumns.find((c) =>
                this.isSameColumnName(c.ColumnName, column.ColumnName)
              );
              if (c) {
                if (c.hasAddCircleButton) column.hasAddCircleButton = true;
                if (c.hasSpecification) column.hasSpecification = true;
                if (c.hasBatchNumber) column.hasBatchNumber = true;
                if (c.hasERP) column.hasERP = true;
                if (c.isClickable) column.isClickable = true;
                if (c.isStatus) column.isStatus = true;
                if (c.multiDatas) column.multiDatas = true;
              }
            });
            this.validColumns = columns;
            this.$nextTick(() => {
              this.syncDivHeight();
            });
          });
      } else {
        allColumns.forEach((column) => {
          let origin = this.$func.getColumnProperty(column.ColumnName);
          if (!column.class) column.class = origin.class;
          if (!column.filter) column.filter = origin.filter;
          if (!column.Width) column.Width = origin.Width || 100;
          if (column.headerText && column.headerText.length > 0) {
            column.text = column.headerText;
          } else if (!column.text || column.text.length == 0) {
            column.text = origin.text || column.ColumnName;
          }
        });
        this.validColumns = allColumns;
        this.$nextTick(() => {
          this.syncDivHeight();
        });
      }
    },
    isSameColumnName(source, target) {
      return (
        String(source || "").toLowerCase() ===
        String(target || "").toLowerCase()
      );
    },
    mousedown(e, column) {
      e.stopPropagation();
      if (this.isBusiness) {
        this.currentTh = column;
        this.startOffset = column.Width - e.pageX;
        this.cursor = "col-resize";
      }
    },
    mousemove(e) {
      if (this.currentTh) {
        let width = this.startOffset + e.pageX;
        if (width < 60) return;
        this.currentTh.Width = width;
        this.syncDivHeight();
      }
    },
    mouseup() {
      if (this.currentTh)
        this.saveColumn(this.currentTh.ColumnName, this.currentTh.Width);
      this.currentTh = undefined;
      this.cursor = "pointer";
    },
    saveColumn(name, width) {
      if (
        this.hasColumnPropertyPersistence &&
        this.validViewName &&
        this.validTableName
      ) {
        this.$api.columnProperties.saveWidth(
          this.validViewName,
          this.validTableName,
          name,
          width
        );
      }
    },
    onSavedColumnProperty(cols) {
      this.$api.columnProperties
        .save(this.validViewName, this.validTableName, cols)
        .then(() => {
          this.updateValidColumns();
          this.onClosedColumnProperty();
        });
    },
    onClosedColumnProperty() {
      this.columnPropertyModalTrigger = false;
    },
    openColumnPropertySetting() {
      const toggle = this.$refs.columnPropertySetting;
      if (toggle) {
        const rect = toggle.getBoundingClientRect();
        // 根據畫面滾動量加上偏移
        this.modalPosition = {
          top: rect.top + window.scrollY,
          right: window.innerWidth - rect.right - 10,
        };
      }
      this.columnPropertyModalTrigger = true;
      this.$nextTick(() => {
        const modal = this.$refs.columnPropertyModal?.$el;
        const toggleRect = toggle?.getBoundingClientRect();
        if (modal && toggleRect) {
          const modalHeight = Math.min(
            modal.offsetHeight,
            window.innerHeight * 0.9
          );
          const padding = 8;

          // 若 modal 太高，計算合適的 top
          const viewportTop = window.scrollY + padding;
          const viewportBottom = window.scrollY + window.innerHeight - padding;
          const preferredTop = toggleRect.top + window.scrollY;

          if (preferredTop + modalHeight > viewportBottom) {
            this.modalPosition.top = Math.max(
              viewportTop,
              toggleRect.bottom + window.scrollY - modalHeight
            );
          }
        }
      });
      document.addEventListener("click", this.hideColumnPropertySetting, true);
    },
    hideColumnPropertySetting(e) {
      if (e.target.closest(".column-property-modal")) return;
      this.columnPropertyModalTrigger = false;
      document.removeEventListener("click", this.hideColumnPropertySetting);
    },
    syncDivHeight() {
      this.$nextTick(() => {
        const thead = document.getElementById(this.id);
        const fixedDiv = document.getElementById(
          `columnPropertySetting-${this.id}`
        );
        if (thead && fixedDiv) {
          const height = thead.offsetHeight;
          fixedDiv.style.height = `${height}px`;
        }
      });
    },
    enableMouseDragScroll() {
      const el = this.$refs.table;
      if (!el) return;

      this._handleMouseDown = (e) => {
        this._isDragging = true;
        el.classList.add("dragging");
        this._startX = e.pageX - el.offsetLeft;
        this._startY = e.pageY - el.offsetTop;
        this._scrollLeft = el.scrollLeft;
        this._scrollTop = el.scrollTop;
      };

      this._handleMouseLeave = () => {
        this._isDragging = false;
        el.classList.remove("dragging");
      };

      this._handleMouseUp = () => {
        this._isDragging = false;
        el.classList.remove("dragging");
      };

      this._handleMouseMove = (e) => {
        if (!this._isDragging) return;
        e.preventDefault();
        const x = e.pageX - el.offsetLeft;
        const y = e.pageY - el.offsetTop;
        const walkX = x - this._startX;
        const walkY = y - this._startY;
        el.scrollLeft = this._scrollLeft - walkX;
        el.scrollTop = this._scrollTop - walkY;
      };

      el.addEventListener("mousedown", this._handleMouseDown);
      el.addEventListener("mouseleave", this._handleMouseLeave);
      el.addEventListener("mouseup", this._handleMouseUp);
      el.addEventListener("mousemove", this._handleMouseMove);
    },
    disableMouseDragScroll() {
      const el = this.$refs.table;
      if (!el) return;

      el.removeEventListener("mousedown", this._handleMouseDown);
      el.removeEventListener("mouseleave", this._handleMouseLeave);
      el.removeEventListener("mouseup", this._handleMouseUp);
      el.removeEventListener("mousemove", this._handleMouseMove);
    },
  },
  beforeUnmount() {
    this.disableMouseDragScroll(); // 很重要
  },
  mounted() {
    if (this.isBusiness) {
      document.addEventListener("mousemove", this.mousemove);
      document.addEventListener("mouseup", this.mouseup);
    }
    // if (this.validTableName) {
    //   this.updateValidColumns();
    // }
    // this.enableMouseDragScroll();
  },
};
</script>
